export default __webpack_public_path__ + "ab196f17aa627b3d4e8c673194c8cf3e.png";